import { GreyinfoColoredIcon } from '@carboncopyco/icons';
import type { WorkspaceMember } from '@carboncopyco/types';
import { List, Separator, TextCaption, TooltipBubble } from '@carboncopyco/ui';
import { capitalize } from '@carboncopyco/utils';
import classNames from 'classnames';
import { InfiniteList } from '../../InfiniteList';
import { MembersModalSkeleton } from './MembersModalSkeleton';
import { WorkspaceMemberRow } from './WorkspaceMemberRow';
import type { TableColumns } from './WorkspaceMembersModal';

export const WorkspaceMembersTable = ({
  members,
  columns,
  userId,
  removeMember,
  fetchMoreMembers,
  isLoadingMembers,
  isLoadingMoreMembers,
  showRowDropdown,
}: {
  members: WorkspaceMember[];
  columns: TableColumns;
  userId: string;
  removeMember: (id: string) => void;
  fetchMoreMembers: () => void;
  isLoadingMembers: boolean;
  isLoadingMoreMembers: boolean;
  showRowDropdown?: boolean;
}) => {
  return (
    <>
      <div className="w-full flex items-center px-ds-5 py-ds-6">
        {Object.values(columns).map((column) => (
          <div
            key={`col-header-${column.title}`}
            className={classNames(column.width)}
          >
            <TextCaption label={capitalize(column.title)} />
          </div>
        ))}
        <TooltipBubble
          title="Roles can be managed by admins at the organization level"
          placement="top"
          fixedWidth={false}
        >
          <div className="cursor-help ml-2">
            <GreyinfoColoredIcon size={16} />
          </div>
        </TooltipBubble>
      </div>
      <Separator horizontal />
      <div className="h-64">
        <InfiniteList
          bottomOffset={10}
          onReachBottom={() => {
            fetchMoreMembers();
          }}
          isLoading={isLoadingMembers}
          isLoadingBatch={isLoadingMoreMembers}
          loader={<MembersModalSkeleton />}
          loaderPlaceholderSpace={24}
        >
          <List
            noSpacing
            data={members}
            renderItem={(member) => (
              <WorkspaceMemberRow
                member={member}
                columns={columns}
                removeMember={() => removeMember(member.id)}
                isCurrentUser={userId === member.user.id}
                showDropdownButton={showRowDropdown}
              />
            )}
          />
        </InfiniteList>
      </div>
    </>
  );
};
